import React, { useState } from "react";
import PropTypes from "prop-types";
import Markdown from "markdown-to-jsx";
import "@fortawesome/fontawesome-free/css/all.css";
import styles from "./index.module.scss";

function SpotlightSection({
  title,
  paragraph1,
  paragraph2,
  logoURL,
  logoAlt,
  ctaURL,
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const expand = () => {
    setIsExpanded(true);
  };

  return (
    <>
      <h2 className={styles.title}>{title}</h2>
      <Markdown>{paragraph1}</Markdown>
      {logoURL && <img src={logoURL} alt={logoAlt} className={styles.logo} />}
      <div onClick={expand} onKeyDown={expand} role="button" tabIndex={0}>
        <Markdown
          className={`${styles.text} ${isExpanded ? styles.expanded : ""}`}
        >
          {paragraph2}
        </Markdown>
      </div>
      <a className={styles.cta} href={ctaURL}>
        LEARN MORE
      </a>
    </>
  );
}

SpotlightSection.propTypes = {
  title: PropTypes.string.isRequired,
  paragraph1: PropTypes.string.isRequired,
  paragraph2: PropTypes.string.isRequired,
  logoURL: PropTypes.string.isRequired,
  logoAlt: PropTypes.string.isRequired,
  ctaURL: PropTypes.string.isRequired,
};

export default SpotlightSection;
